import { getApp } from 'firebase/app';
import { getAuth, signInAnonymously } from 'firebase/auth';
import React from 'react';

export default function wrapRootElement({ element }) {
  return <FirebaseAuthProvider>{element}</FirebaseAuthProvider>;
}

function FirebaseAuthProvider({ children }) {
  const app = useFirebaseApp();
  useSignInAnonymously();
  const auth = getAuth(app);
  return <AuthProvider sdk={auth}>{children}</AuthProvider>;
}

function useSignInAnonymously() {
  const app = useFirebaseApp();
  const auth = getAuth(app);
  React.useEffect(() => {
    signInAnonymously(auth)
      .then(() => {
        // Signed in..
      })
      .catch((error) => {
        // const errorCode = error.code;
        // const errorMessage = error.message;
        // ...
      });
  });
}

// These hooks are modeled after reactfire - although it's not possible to use it currently (SSR issues), the API is good.
function useFirebaseApp() {
  return getApp();
}

function AuthProvider({ children, sdk }) {
  return <>{children}</>;
}
